export function checkInvalidField(value, fieldSchema) {
  var formErrorMessage = "";
  if (
    (value === null && !fieldSchema.nullable) ||
    (value === "" && !fieldSchema.nullable)
  ) {
    formErrorMessage = "Missing required field: " + fieldSchema.name;
  }

  return formErrorMessage;
}
